import { Layout } from 'antd';
import React, { useState } from 'react';
import { Header } from './Header';
import Sidebar from './Sidebar';

const { Content } = Layout;

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Header />
      <Layout style={{ marginTop: 64, minHeight: 'calc(100vh - 64px)' }}>
        <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
        <Layout style={{ marginLeft: collapsed ? 80 : 240, transition: 'margin-left 0.2s' }}>
          <Content
            style={{
              flex: 1,
              padding: '24px',
              maxWidth: '100%',
              overflow: 'auto',
              margin: 0,
            }}
          >
            <div style={{ maxWidth: '1400px', margin: '0 auto' }}>{children}</div>
          </Content>
        </Layout>
      </Layout>
    </div>
  );
}
